import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import { Button } from './Button';
import styles from './SuccessModal.module.css';

interface SuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    subMessage?: string;
}

export function SuccessModal({ isOpen, onClose, title, message, subMessage }: SuccessModalProps) {
    if (!isOpen) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.iconWrapper}>
                    <CheckCircle size={48} className={styles.icon} />
                </div>

                <h3 className={styles.title}>{title}</h3>
                <p className={styles.message}>{message}</p>
                {subMessage && <p className={styles.subMessage}>{subMessage}</p>}

                <div className={styles.actions}>
                    <Button onClick={onClose} variant="primary">
                        Entendido
                    </Button>
                </div>
            </div>
        </div>
    );
}
